import { SEO_LOCALES, hreflangCode, isSeoLocalizedPath, ogLocale, seoPath, stripSeoLang } from "~/constants/seo";

// Site-wide head: canonical, hreflang for the localized public pages, robots
// (noindex on `?url=` variants, mirrored by server/middleware/noindex-url-param.ts),
// the "| DownSub" title template and default Open Graph tags.
export const useSeoHead = () => {
  const route = useRoute();
  const config = useRuntimeConfig();
  const { locale } = useI18n();
  const requestUrl = useRequestURL();
  const siteUrl = ((config.public.siteUrl as string) || requestUrl.origin).replace(/\/+$/, "");

  const canonical = computed(() => `${siteUrl}${route.path}`);

  useHead({
    titleTemplate: (title) => (title ? `${title} | DownSub` : "DownSub"),
  });

  useHead(
    computed(() => {
      const base = stripSeoLang(route.path);
      const link = [{ rel: "canonical", href: canonical.value }];
      if (isSeoLocalizedPath(route.path)) {
        link.push(
          { rel: "alternate", hreflang: "x-default", href: `${siteUrl}${base}` },
          { rel: "alternate", hreflang: "en", href: `${siteUrl}${base}` },
          ...SEO_LOCALES.map((l) => ({ rel: "alternate", hreflang: hreflangCode(l), href: `${siteUrl}${seoPath(base, l)}` })),
        );
      }
      return {
        link,
        meta: [{ name: "robots", content: route.query.url ? "noindex, nofollow" : "index, follow" }],
      };
    }),
  );

  useSeoMeta({
    ogType: "website",
    ogSiteName: "DownSub",
    ogUrl: () => canonical.value,
    ogLocale: () => ogLocale(locale.value),
    ogImage: `${siteUrl}/og-default.png`,
    ogImageWidth: 1200,
    ogImageHeight: 630,
    twitterCard: "summary_large_image",
  });
};
